import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../../../shared/api";
import { BaseResponse } from "../../../shared/types";
import {
  CitiesResponse,
  CityRequestResponse,
  CityRequestsResponse,
  CityResponse,
  CreateCityRequest,
  UpdateCityRequest,
} from "./types";

export const adminCityApi = createApi({
  reducerPath: "adminCityApi",
  baseQuery: baseApiQuery,
  tagTypes: ["Cities", "CityRequests"],
  endpoints: (builder) => ({
    // Города
    getCities: builder.query<CitiesResponse, void>({
      query: () => "/admin/cities",
      providesTags: ["Cities"],
    }),

    createCity: builder.mutation<CityResponse, CreateCityRequest>({
      query: (body) => ({
        url: "/admin/cities",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Cities"],
    }),

    updateCity: builder.mutation<
      CityResponse,
      { id: number; body: UpdateCityRequest }
    >({
      query: ({ id, body }) => ({
        url: `/admin/cities/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Cities"],
    }),

    deleteCity: builder.mutation<BaseResponse, number>({
      query: (id) => ({
        url: `/admin/cities/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Cities"],
    }),

    // Запросы городов
    getCityRequests: builder.query<CityRequestsResponse, void>({
      query: () => "/admin/cities/requests",
      providesTags: ["CityRequests"],
    }),

    approveCityRequest: builder.mutation<CityRequestResponse, number>({
      query: (id) => ({
        url: `/admin/cities/requests/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["CityRequests", "Cities"],
    }),

    rejectCityRequest: builder.mutation<CityRequestResponse, number>({
      query: (id) => ({
        url: `/admin/cities/requests/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CityRequests"],
    }),
  }),
});

export const {
  useGetCitiesQuery,
  useCreateCityMutation,
  useUpdateCityMutation,
  useDeleteCityMutation,
  useGetCityRequestsQuery,
  useApproveCityRequestMutation,
  useRejectCityRequestMutation,
} = adminCityApi;
